<template>
  <div class="modal-card has-background-white">
    <header class="modal-card-header px-5 pt-5">
      <p class="modal-card-title">
        Select users ({{ checkedRows.length }} / {{ users.length }})
      </p>
    </header>
    <small
      @click="selectAll"
      class="mt-5 mx-5 is-size-6 has-text-primary is-underlined is-clickable"
      v-if="users.length > 5 && checkedRows.length < users.length"
      >Select all {{ users.length }} users</small
    >
    <div class="modal-card-body" style="height: 100%">
      <b-table
        :data="users"
        :checked-rows.sync="checkedRows"
        checkable
        paginated
        pagination-simple
        per-page="5"
      >
        <b-table-column field="name" label="Name" v-slot="props">
          {{ props.row.name }}
        </b-table-column>

        <b-table-column field="email" label="Email" v-slot="props">
          {{ props.row.email }}
        </b-table-column>

        <b-table-column
          field="last_login"
          label="Last Login"
          centered
          v-slot="props"
        >
          <b-tooltip
            position="is-left"
            :label="props.row.last_login"
            :active="props.row.last_login"
            type="is-success"
          >
            <span
              class="tag"
              :class="[props.row.last_login ? 'is-success' : 'is-danger']"
            >
              {{
                props.row.last_login
                  ? dateFromNow(props.row.last_login)
                  : 'Never'
              }}
            </span>
          </b-tooltip>
        </b-table-column>
      </b-table>
    </div>
    <footer class="modal-card-foot">
      <b-button label="Confirm" @click.prevent="confirm" type="is-success" />
    </footer>
  </div>
</template>
<script>
import * as dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export default {
  props: {
    users: Array,
  },
  data() {
    return {
      columns: [
        { field: 'name', label: 'Name' },
        { field: 'email', label: 'Email' },
        { field: 'last_login', label: 'Last Login', centered: true },
      ],
      checkedRows: this.users.filter((user) => user.checked),
    };
  },
  methods: {
    dateFromNow(date) {
      return dayjs(date).fromNow();
    },
    selectAll() {
      this.checkedRows = this.users;
    },
    confirm() {
      this.$emit('confirmed', this.checkedRows);
      this.$parent.close();
    },
  },
};
</script>
